import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { MbmProvider } from '@amzn/react-arb-tools';
import Theme from '@amzn/meridian/theme';
import { AnalyticsProvider } from './common/metrics/AnalyticsContext';
import { router } from './router';
import { queryClient } from './api/queryClient';
import mbmOptions from './i18n/utils/mbmOptions';
import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import '@amzn/meridian-tokens/base/font/bookerly.css';
import './globalStyles.scss';
const container = document.getElementById('root');
const root = createRoot(container);
/**
 * The theme from Meridan handles light and dark mode for the entire application.
 * While this uses @emotion under the hood, it does not connect to @emotion/styled
 * or @emotion/react which is needed to do theming efficiently. Therefore, we've
 * enabled a second ThemeProvider in App.tsx to handle Rio theming within @emotion/styled
 */
root.render(_jsx(React.StrictMode, { children: _jsx(AnalyticsProvider, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(MbmProvider, Object.assign({}, mbmOptions, { children: _jsx(Theme, { mode: "auto", children: _jsx(RouterProvider, { router: router }) }) })) }) }) }));
